<template>

  <div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2" v-if="editMode">Editer une section</h1>
        <h1 class="h2" v-else>Créer une nouvelle section</h1>
    </div>

    <h2 class="mt-5">Les informations de la section</h2>
    <quiz-information></quiz-information>

    <h2 class="mt-5">Les questions de la section</h2>
    <quiz-questions />
    <quiz-actions
      :action="createQuiz"
      :actionName="actionName"
    >
    </quiz-actions>

    </div>

</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  import QuizInformation from '@/components/quiz/QuizInformation';
  import QuizQuestions from '@/components/quiz/QuizQuestions';
  import QuizActions from '@/components/quiz/QuizActions';

  export default {
    name: 'create-quiz',

    components: {
      QuizInformation,
      QuizQuestions,
      QuizActions
    },

    data() {
      return {
        editMode: false,
      }
    },

    created() {
      require ("@/assets/js/quill.js");
      require ("@/assets/css/quill.snow.css");

      // get the quiz using the id passed in url params
      if (this.$route.params.id !== undefined){
        this.editMode = true;
        this.getQuiz({
          "id": this.$route.params.id,
          "editMode": this.editMode
        });
      }
    },

    computed: {

      ...mapGetters('quiz',
          {newQuiz: 'newQuiz'}
      ),

      actionName() {
        if (this.editMode==true) {
          return "Update";
        } else {
          return "Save";
        }
      }
    },

    methods: {
      ...mapActions('quiz', {
        create: 'create',
        getQuiz: 'get'
      }),

      async createQuiz(stay) {
        var isOk = true;
        var error = "";
        console.log(this.newQuiz.questions);
        for (let question of this.newQuiz.questions) {
          if (typeof(question.questionType) == "undefined") {
            error = "Il manque un 'type de question' sur l'une des questions.";
            isOk = false;
          };
          if (typeof(question.resultat_texte) == "undefined" || question.resultat_texte=="") {
            error = "L'une des bonnes pratiques est vide";
            isOk = false;
          };
        };
        if (isOk) {
          try {
            await this.create({
            "id": this.$route.params.id,
            "editMode": this.editMode
          });
            if (stay) {
              return;
            }
            else {
              this.$router.push({ name: 'Admin Survey'});
            }
          } catch(error) {
            alert('Something went wrong');
          }
        } else {
          alert('Something is missing in your form (check that all question types are set - most frequent error). \n It could also happen when you add a link to a "Bonne pratique" because it erase the text in cache. You need to enter into the edited text boxes and add a space or something like this to refresh.\n\n Error : '+ error);
        }
      }
    }
  }
</script>


<style scoped>
h2 {
  color: #005E88;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminCreate.vue